// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"101447f6","732":"03adb4ce","977":"c189bc8a"}[chunkId] + ".chunk.js";
};